export const BlogLength = {
  TWO: 'TWO',
  FIVE: 'FIVE',
  TEN_PLUS: 'TEN_PLUS',
} as const;
export type BlogLength = (typeof BlogLength)[keyof typeof BlogLength];
export const BLOG_SECTION_PREFIX = 'section-';

export const Author = {
  DOL: 'DOL',
} as const;

export type Author = (typeof Author)[keyof typeof Author];

export const BlogContentGroup = {
  READING: 'READING',
  LISTENING: 'LISTENING',
  WRITING: 'WRITING',
  SPEAKING: 'SPEAKING',
  EXPERIENCE_SHARING: 'EXPERIENCE_SHARING',
  GRAMMAR: 'GRAMMAR',
  VOCAB: 'VOCAB',
} as const;

export type BlogContentGroup = (typeof BlogContentGroup)[keyof typeof BlogContentGroup];

export const CourseLevelEnum = {
  BASIC: 'BASIC',
  ADVANCED: 'ADVANCED',
  INTENSIVE: 'INTENSIVE',
} as const;

export type CourseLevelEnum = (typeof CourseLevelEnum)[keyof typeof CourseLevelEnum];

export const BOOK_DOCUMENT_TYPE_STATUS_OPTIONS = [
  { label: 'All', value: null },
  { label: 'Sách lẻ', value: 'BOOK' },
  { label: 'Bộ sách', value: 'BOOKS' },
  { label: 'Web/app tự học', value: 'WEBSITE_APP_STUDY' },
];

export const BOOK_SKILLS_OPTIONS = [
  { label: 'All', value: null },
  { label: 'Grammar', value: 'GRAMMAR' },
  { label: 'Listening', value: 'LISTENING' },
  { label: 'Reading', value: 'READING' },
  { label: 'Speaking', value: 'SPEAKING' },
  { label: 'Vocab', value: 'VOCAB' },
  { label: 'Writing', value: 'WRITING' },
];

export const BOOK_SKILLS_DROPDOWN = [
  { label: 'Grammar', value: 'GRAMMAR' },
  { label: 'Listening', value: 'LISTENING' },
  { label: 'Reading', value: 'READING' },
  { label: 'Speaking', value: 'SPEAKING' },
  { label: 'Vocab', value: 'VOCAB' },
  { label: 'Writing', value: 'WRITING' },
];

export const BOOK_LEVEL_OPTIONS = [
  { label: 'All', value: null },
  { label: 'Cơ bản', value: 'BASIC' },
  { label: 'Cấp tốc', value: 'INTERMEDIATE' },
  { label: 'Nâng cao', value: 'ADVANCED' },
];

export const BOOK_LEVEL_DROPDOWN = [
  { displayName: 'Cơ bản', value: 'BASIC' },
  { displayName: 'Cấp tốc', value: 'INTERMEDIATE' },
  { displayName: 'Nâng cao', value: 'ADVANCED' },
];

export const BLOG_CONTENT_GROUP_DROPDOWN = [
  { displayName: 'Reading', value: 'READING' },
  { displayName: 'Listening', value: 'LISTENING' },
  { displayName: 'Writing', value: 'WRITING' },
  { displayName: 'Speaking', value: 'SPEAKING' },
  { displayName: 'Chia sẻ kinh nghiệm', value: 'EXPERIENCE_SHARING' },
  { displayName: 'IELTS Grammar', value: 'GRAMMAR' },
  { displayName: 'IELTS Vocabulary', value: 'VOCAB' },
];

export const BLOG_TYPE_DROPDOWN = [
  { displayName: 'Reading', value: 'READING' },
  { displayName: 'Listening', value: 'LISTENING' },
  { displayName: 'Writing', value: 'WRITING' },
  { displayName: 'Speaking', value: 'SPEAKING' },
  { displayName: 'Review sách', value: 'BOOK_REVIEW' },
  { displayName: 'Center Review', value: 'CENTER_REVIEW' },
  { displayName: 'Teacher Review', value: 'TEACHER_REVIEW' },
  { displayName: 'Course Review', value: 'COURSE_REVIEW' },
  { displayName: 'Tổng quan về IELTS', value: 'IELTS_INFO' },
  { displayName: 'BLOG_TYPE_GRAMMAR', value: 'GRAMMAR' },
  { displayName: 'BLOG_TYPE_VOCAB', value: 'VOCAB' },
];

export const BOOK_DOCUMENT_TYPE_DROPDOWN = [
  { displayName: 'Sách lẻ', value: 'BOOK' },
  { displayName: 'Bộ sách', value: 'BOOKS' },
  { displayName: 'Web/app tự học', value: 'WEBSITE_APP_STUDY' },
];

export const IELTS_INFO_TYPE_OPTIONS = [
  { label: 'All', value: null },
  { label: 'Kỳ thi IELTS', value: 'IELTS_EXAM' },
  { label: 'Kinh nghiệm tự học', value: 'SELF_EXPERIENCE' },
];

export const IELTS_INFO_TYPE_DROPDOWN = [
  { displayName: 'Kỳ thi IELTS', value: 'IELTS_EXAM' },
  { displayName: 'Kinh nghiệm tự học', value: 'SELF_EXPERIENCE' },
];

export const LOCATION_OPTIONS = [
  { label: 'All', value: null },
  { label: 'Tp Hồ Chí Minh', value: 'HCM' },
  { label: 'Toàn Quốc', value: 'NATION' },
  { label: 'Online', value: 'ONLINE' },
];

export const LOCATION_DROPDOWN = [
  { label: 'Tp Hồ Chí Minh', value: 'HCM' },
  { label: 'Toàn Quốc', value: 'NATION' },
  { label: 'Online', value: 'ONLINE' },
];

export const COURSE_LEVELS_OPTIONS = [
  { label: 'All', value: null },
  { label: 'Cơ bản', value: 'BASIC' },
  { label: 'Nâng cao', value: 'ADVANCED' },
  { label: 'Cấp tốc', value: 'INTENSIVE' },
];

export const COURSE_LEVELS_DROPDOWN = [
  { label: 'Cơ bản', value: 'BASIC' },
  { label: 'Nâng cao', value: 'ADVANCED' },
  { label: 'Cấp tốc', value: 'INTENSIVE' },
];
